import { render, staticRenderFns } from "./SecondMenuItem.vue?vue&type=template&id=4091b661&"
import script from "./SecondMenuItem.vue?vue&type=script&lang=js&"
export * from "./SecondMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./SecondMenuItem.vue?vue&type=style&index=0&id=4091b661&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports